<template>
  <div class="messaging-description-container">
    <div class="messaging-description-container-data">
      <div class="checkbox-wrapper">
        <vwc-formfield class="description-checkBox">
          <vwc-checkbox
              @click="ackChecked"
              :checked="isAckChecked"
              :disabled="disabled"
              class="cta-checkbox"
          ></vwc-checkbox>
        </vwc-formfield>
        <span class="header" :class="{'disabled': disabled}">{{ header }}</span>
        <cd-tooltip :tool-tip-info="toolTipInfo" :id="toolTipInfo.id"  class="icon"/>
      </div>
      <slot name="messaging-description-check-box-body"></slot>
    </div>
  </div>
</template>

<script>
import CdTooltip from "../atomicUIComponents/tooltip/CdTooltip";
export default {
  name: "MessagingDescriptionCheckBox",
  components: {CdTooltip},

  props: {
    header: {
      type: String,
      default: '',
    },
    isAckChecked: {
      type: Boolean,
      default: false,
    },
    toolTipInfo : {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods : {
    ackChecked() {
      if (this.disabled) {
        return;
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.isAckChecked = !this.isAckChecked;
      this.$emit('checkBox',this.isAckChecked)
    },
    copy(val) {
      const tempInput = document.createElement("textarea");
      tempInput.value = val;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand("copy");
      document.body.removeChild(tempInput);
      this.$refs.copiedToClipboardSnackbar.show();
    },
  }
}
</script>

<style scoped>
.messaging-description-container{
  min-height: 80px;
  border: 1px solid #CCCCCC;
  border-radius: 8px;
  margin: 16px 0px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 24px 24px 8px;
}

.header.disabled {
  color: #555555;
}

.messaging-description-container-data{
  width: 100%;
}

.checkbox-wrapper{
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
}

.icon {
  width: 20px;
  height: 20px;
  position: absolute;
  right: 22px;
}

.disclaimer {
  margin-bottom: 16px;
}

.disclaimer-note {
  padding: 20px;
  gap: 16px;
  border-radius: 8px;
  background: #E8F4FB;
  border: 1px solid #0276D5;
  display: flex;
}
.disclaimer-explanation{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.disclaimer-hover{
  color: #7C3AED;
  text-decoration: underline;
  margin-left: 4px;
  cursor: default;
}

.cta-checkbox {
  --mdc-checkbox-checked-color: #9941FF;
}
</style>
